module.exports = __webpack_public_path__ + "static/media/reserveSpot.e549561f.svg";